// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "mm-modal[data-v-300d4346]::part(header) {\n  font-size: 24px;\n  color: #1a1a1a;\n  font-weight: 450;\n  line-height: 32px;\n}\nmm-modal[data-v-300d4346]::part(content) {\n  padding: 0;\n}\n.ifs-modal-buttons[data-v-300d4346] {\n  display: flex;\n  width: 100%;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
